module.exports = __webpack_public_path__ + "static/media/example1.c1f400e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/About/example1.gif
// module id = 1238
// module chunks = 2